import TradeWorkTitleCreatePage from './trade-work-title -create-page';
export default function Mainpage() {
  return (
    <>
      <TradeWorkTitleCreatePage />
    </>
  );
}
